module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_header_report-b540d89ba0e0503a21c04c1a6d8b0420.svg";